import React, { Component, Fragment } from 'react';

import { getColors, hasLowerCase, capitalize } from 'utilities/utilities';
import { OKBoxOptions } from 'commonsComponents/OKBoxOptions';
import AccordionTab from '../accordionTab/accordionTab.jsx';


const PropTypes = require('prop-types');

const boxProps = {
  rowItems: 3,
  multiSelection: true,
  shadow: false,
  check: true,
  type: 'COLUMN_RIGHT_TYPE',
  spaceBetweenBox: true,
  optionSelected: [],
};

class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openTabs: this.getInitialOpenTabs(),
    };
  }

  getInitialOpenTabs = () => {
    const {content, allTabsClosed} = this.props;
    let firstTab;
    firstTab = allTabsClosed ? null : content.sort((a,b)=>(a.id-b.id)).map((item) => item.id)[0];
    const tabsWithSelected = content.filter(item =>(item.content.filter(ngo=> ngo.selected).length > 0 ? item.id : false)).map(category => category.id);
    return(tabsWithSelected.length === 0 ? [firstTab] : tabsWithSelected);
  }

  handler = (index) => {
    const { openTabs } = this.state;
    const { sigleOpenTab } = this.props;
    if(sigleOpenTab){
      const newOpen = openTabs.includes(index) ? openTabs.filter(tab => (tab !== index)) : [index];
      this.setState({
        openTabs: newOpen,
      });
   }else{
     const newOpen = openTabs.includes(index) ? openTabs.filter(tab => (tab !== index)) : [...openTabs, index];
     this.setState({
       openTabs: newOpen,
     });
   }

  }

  changeNGOSelected = (selectedOption) => {
    const { handleSelected } = this.props;

    handleSelected(selectedOption)
  }

  render() {
    const {
      content, selected, maxSelection, itemCompareSelected, FormattedText, deleteLastOneOption
    } = this.props;

    const { openTabs } = this.state;
    return (
        <Fragment>
            {content.sort((a,b)=>(a.id-b.id)).map((item) => {
              const { image, content, id, name, color } = item;

              const selectedItems = selected.length === 0 ? [] : content.filter(option => selected.includes(option.ngoId));

              const boxPropsNew = {...boxProps};

              //Fix names. Check if name has already lowercase (in that case I supose they are ok), and capitalice them if not (they usually are full caps)
              const contentFixNames = content.map(option => {
                const newOption = { ...option };
                if (!hasLowerCase(newOption.titleOption)) {newOption.titleOption = capitalize(newOption.titleOption, true);}
                return (newOption);
              });

              boxPropsNew.options = contentFixNames;
              boxPropsNew.itemCompareSelected = itemCompareSelected;
              boxPropsNew.optionSelected = selectedItems;
              boxProps.deleteLastOneOption = deleteLastOneOption;
              boxPropsNew.callbackOnClick = selectedOption => this.changeNGOSelected(selectedOption);
              boxPropsNew.multiSelectionMax = maxSelection - selected.length + selectedItems.length;

              return (
                  <AccordionTab
                      key={id}
                      title={name}
                      total={boxPropsNew.options.length}
                      selected={boxPropsNew.optionSelected.length}
                      image={image}
                      color={color|| getColors(id)}
                      isOpen={openTabs.includes(id)}
                      handler={() => (this.handler(id))}
                      rows={Math.ceil(boxPropsNew.options.length/boxPropsNew.rowItems)}
                      FormattedText={FormattedText}
                      // heightTab={this[`boxOptions${id}`] && this[`boxOptions${id}`].clientHeight}
                  >
                      <div ref={box => {this[`boxOptions${id}`] = box}}>
                          <OKBoxOptions {...boxPropsNew} />
                      </div>
                  </AccordionTab>
              );
            })
            }
        </Fragment>
    );
  }
}

Accordion.propTypes = {
  maxSelection: PropTypes.number.isRequired,
  content: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  handleSelected: PropTypes.func.isRequired,
  sigleOpenTab: PropTypes.bool.isRequired,
  itemCompareSelected: PropTypes.string,
  FormattedText: PropTypes.func,
  allTabsClosed: PropTypes.bool,
  deleteLastOneOption: PropTypes.bool
};

Accordion.defaultProps = {
  FormattedText: () => {throw "FormattedText not defined"}
};

export default Accordion;
